import { render, staticRenderFns } from "./deliveryZones.vue?vue&type=template&id=7d6e4930&"
import script from "./deliveryZones.vue?vue&type=script&lang=js&"
export * from "./deliveryZones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports